module.exports = __webpack_public_path__ + "static/media/IMG_1384a.743cf06e.jpg";